import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const usuarioSchema = (t: TFunction, cpfOriginal?: string) => {
  const v = createValidation(t)

  return Yup.object().shape({
    primeiroNome: Yup.string().required(v.requiredField('primeiroNome')),
    sobreNome: Yup.string().required(v.requiredField('sobrenome')),
    email: Yup.string().email('E-mail inválido').required(v.requiredField('email')),
    cpf: Yup.string().required(v.requiredField('cpf')),
    sexo: Yup.object().nullable().required(v.requiredField('sexo', 'select')),
    nascimento: Yup.string().required(v.requiredField('data_nascimento')),
    grupo: Yup.object().nullable().required(v.requiredField('grupo', 'select')),
    perfis: Yup.array().of(Yup.object()).min(1, v.requiredField('permissao', 'array')),
    ativo: Yup.object().nullable().required(v.requiredField('situacao', 'select')),
    justificativa: Yup.string().when('cpf', {
      is: (cpf?: string) => cpf !== cpfOriginal,
      then: (schema) => schema.required('A justificativa é obrigatória quando o CPF é alterado'),
    }),
  })
}
